import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  message,
  Row,
  Select,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "./WizardConfig.css";

import { postAuthConfig } from "../../api/requests";
import { logout, setAppSettings } from "../../reducers/user/actions";

class AuthConfigForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      authConfigData: {},
      isLoadingData: false,
      isLoading: false,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.authConfigData.is_configured !==
      this.props.authConfigData.is_configured
    ) {
      this.setData();
    }
  }

  setData = () => {
    this.setState({
      authConfigData: this.props.authConfigData,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      errorMessage: null,
    });
    this.props.form.validateFields(async (err, values) => {
      const data = { ...values };

      try {
        await postAuthConfig(data);
        message.success(this.props.i18n.t("Saved"));
        this.props.setAppSettings();
        this.props.onSubmit();
      } catch (e) {
        if (get(e, "response.data.errors")) {
          const errors = {};
          Object.keys(get(e, "response.data.errors")).forEach(
            (errorFieldKey) => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                  (errorMessage) => new Error(errorMessage)
                ),
              };
            }
          );
          this.props.form.setFields(errors);
        } else {
          this.setState({
            errorMessage: JSON.stringify(get(e, "response.data.errors")),
          });
        }
        message.error(this.props.i18n.t("Error"));
        console.log(e);
      }
    });
  };

  render() {
    const {
      authConfigData,
      isLoading,
      isLoadingData,
      errorMessage,
    } = this.state;
    const { isDisabled } = this.props;
    const { getFieldDecorator } = this.props.form;
    const isEditable = true;

    return (
      <div className={classes.formWrapper}>
        <h3 className="headline-default">{this.props.i18n.t("NamespaceWizardConfig:Auth config")}</h3>

        {!isLoadingData ? (
          <Form onSubmit={this.handleSubmit}>
            <Row gutter={8}>
              <Col sm={24}>
                <div style={{ width: "250px" }}>
                  <Form.Item label={this.props.i18n.t("Auth type")} required>
                    {getFieldDecorator(`auth_type`, {
                      initialValue: get(authConfigData, `auth_type`, null),
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(
                      <Select
                        disabled={!isEditable || isDisabled}
                        placeholder={this.props.i18n.t("Select")}
                      >
                        <Select.Option disabled value={null}>{this.props.i18n.t("Null")}</Select.Option>
                        <Select.Option value="regular">{this.props.i18n.t("Regular")}</Select.Option>
                        <Select.Option value="saml">{this.props.i18n.t("Saml")}</Select.Option>
                        <Select.Option value="saml_priority_over_regular">{this.props.i18n.t("SAML priority over regular")}</Select.Option>
                        <Select.Option value="regular_priority_over_saml">{this.props.i18n.t("Regular priority over SAML")}</Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div style={{ width: "250px" }}>
                  <Form.Item label={this.props.i18n.t("SAML type")} required>
                    {getFieldDecorator(`saml_type`, {
                      initialValue: get(authConfigData, `saml_type`, null),
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(
                      <Select
                        disabled={!isEditable || isDisabled}
                        placeholder={this.props.i18n.t("Select")}
                      >
                        <Select.Option disabled value={null}>{this.props.i18n.t("Null")}</Select.Option>
                        <Select.Option value="azure">{this.props.i18n.t("Azure")}</Select.Option>
                        <Select.Option value="ping">{this.props.i18n.t("Ping")}</Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>

            <br />
            <Row gutter={8}>
              {errorMessage && (
                <Col span={24}>
                  <Alert message={errorMessage} type="error" />
                </Col>
              )}
              <Col span={24}>
                <Button
                  disabled={!isEditable || isDisabled}
                  type="primary"
                  size="large"
                  htmlType="submit"
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Icon type="loading" />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { setAppSettings, logout };

export default Form.create({ name: "AuthConfigForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(AuthConfigForm))
);



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/AuthConfigForm.js